import RatingScaleDisplay from '../../../../components/raytd/ratings/rating-scale-display';
import { RatingScale as RatingScaleType } from '@app.raytd.com/common/types/rating-scale';
export type ReportScaleWithTitles = RatingScaleType & { titles: string };

interface RatingScaleProps {
  scale: ReportScaleWithTitles;
}

export function RatingScale({ scale }: RatingScaleProps) {

  return (
    <div className="space-y-6 print-rating-scale">
      <div>
        <h3 className="font-medium mb-2">{scale.label}</h3>
        <h4 className="text-sm text-gray-500">This Rating System is used by the following Test Suites: {scale.titles}</h4>
      </div>
      <RatingScaleDisplay scale={scale} />
    </div>
  )
}
